import { TranslateService } from '@ngx-translate/core';
import { Component } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommentDialogResult } from './comment-dialog-result';
import { OrderState } from '../../../core/enums/order-state.enum';

@Component({
	selector: 'cfe-order-comment-dialog',
	templateUrl: './order-comment-dialog.component.html',
	styleUrls: ['./order-comment-dialog.component.scss']
})
export class OrderCommentDialogComponent {
	comment = '';
	state: OrderState;
	OrderState = OrderState;

	constructor(public translate: TranslateService, public activeModal: NgbActiveModal) {}

	close(answer: boolean) {
		const result = new CommentDialogResult();
		result.result = answer;
		if (answer) {
			result.comment = this.comment;
		}

		this.activeModal.close(result);
	}
}
